import { LoggedOutLogoMakerLP } from '@fiverr-private/header/';

export default LoggedOutLogoMakerLP;
